import styled from "styled-components";
import { rem } from 'polished';

const baseFont = `12px`;
const S = {};

const BetSlipCheckLabelColor = ({ theme: { $betSlipCheckLabelColor } }) => `${$betSlipCheckLabelColor}`;
const BetSlipCheckInputColor = ({ theme: { $betSlipCheckInputColor } }) => `${$betSlipCheckInputColor}`;
const BetSlipCheckInputBackground = ({ theme: { $betSlipCheckInputBackground } }) => `${$betSlipCheckInputBackground}`;
const BetSlipCheckButtonColor = ({ theme: { $betSlipCheckButtonColor } }) => `${$betSlipCheckButtonColor}`;
const BetSlipCheckButtonBackground = ({ theme: { $betSlipCheckButtonBackground } }) => `${$betSlipCheckButtonBackground}`;
const BetSlipCheckInputBorderColor = ({ theme: { $betSlipCheckInputBorderColor } }) => `${$betSlipCheckInputBorderColor}`;

const BetSlipDetailsDataBackground = ({ theme: { $betSlipDetailsDataBackground } }) => `${$betSlipDetailsDataBackground}`;
const BetSlipDetailsDataTitleColor = ({ theme: { $betSlipDetailsDataTitleColor } }) => `${$betSlipDetailsDataTitleColor}`;
const BetSlipDetailsListHeaderBackground = ({ theme: { $betSlipDetailsListHeaderBackground } }) => `${$betSlipDetailsListHeaderBackground}`;
const BetSlipDetailsListEventDataBackground = ({ theme: { $betSlipDetailsListEventDataBackground } }) => `${$betSlipDetailsListEventDataBackground }`;
const BetSlipDetailsDataColor = ({ theme: { $betSlipDetailsDataColor } }) => `${$betSlipDetailsDataColor}`;

const BetSlipDetailsListEventDataColor = ({ theme: { $betSlipDetailsListEventDataColor } }) => `${$betSlipDetailsListEventDataColor}`;
const BetSlipDetailsListHeaderColor = ({ theme: { $betSlipDetailsListHeaderColor } }) => `${$betSlipDetailsListHeaderColor}`;
const BetSlipDetailsListEventDataColorDate = ({ theme: { $betSlipDetailsListEventDataColorDate } }) => `${$betSlipDetailsListEventDataColorDate}`;

const BetSlipDetailsListStatusPending = ({ theme: { $betSlipDetailsListStatusPending } }) => `${$betSlipDetailsListStatusPending}`;
const BetSlipDetailsListStatusPlaced = ({ theme: { $betSlipDetailsListStatusPlaced } }) => `${$betSlipDetailsListStatusPlaced}`;
const BetSlipDetailsListStatusWon = ({ theme: { $betSlipDetailsListStatusWon } }) => `${$betSlipDetailsListStatusWon}`;
const BetSlipDetailsListStatusLost = ({ theme: { $betSlipDetailsListStatusLost } }) => `${$betSlipDetailsListStatusLost}`;
const BetSlipDetailsListStatusCancel = ({ theme: { $betSlipDetailsListStatusCancel } }) => `${$betSlipDetailsListStatusCancel}`;
const BetSlipDetailsListStatusCashout = ({ theme: { $betSlipDetailsListStatusCashout } }) => `${$betSlipDetailsListStatusCashout}`;
const BetSlipDetailsListStatusDefault = ({ theme: { $betSlipDetailsListStatusDefault } }) => `${$betSlipDetailsListStatusDefault}`;

S.BetSlipCheckContent = styled.form`
    width: 100%;
    border-top: 2px solid  ${BetSlipDetailsDataBackground};
    border-bottom: 2px solid  ${BetSlipDetailsDataBackground};
`;

S.FormGroupWrapper = styled.div`
    margin-bottom: 20px;
    height: 44px;
    margin: 23px 0;
`;

S.Label = styled.label`
    font-size: 1.3rem;
    color: ${BetSlipCheckLabelColor};
    font-weight: normal;
    margin: auto 0;

`;

S.Input = styled.input`
    font-size: 1.3333rem;
    background-color: transparent;
    border: none;
    padding-right: 0.5rem;
    color: ${BetSlipCheckInputColor};
    background-color: ${BetSlipCheckInputBackground};
    border: 1px solid ${BetSlipCheckInputBorderColor};
    border-radius: 4px;
    height: 2.7rem;
    padding: 0.5rem 1rem;
    margin: 0 1rem;
    text-align: middle;
`;

S.Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    font-size: 1.3333rem;
    color: ${BetSlipCheckButtonColor};
    background-color: ${BetSlipCheckButtonBackground};
    height: 100%;
    border: none;
    border-radius: 5px;
    text-align: center;
    padding: 0 33px;
    text-transform: uppercase;
    line-height: 100%;
`;

S.BetSlipDetailsWrapper = styled.div`
    width: 100%;
    
    padding: 0 ${rem('40px', baseFont)} ${rem('40px', baseFont)};
`;

S.BetSlipInformationWrapper = styled.div`
    margin: 23px 0 15px;
`;

S.InformationCellWrapper = styled.div`
    &:not(:first-child) {
        margin-left: 2px;
    }
`;

S.InformationTitle = styled.div`
    font-weight: bold;
    color: ${BetSlipDetailsDataTitleColor};
`;

S.InformationData = styled.div`
    background-color: ${BetSlipDetailsDataBackground};
    color: ${BetSlipDetailsDataColor};
    font-weight: bold;
    height: 30px;
    width: 100%;
    margin-top: 8px;
    line-height: 14px;
`;


S.BetSlipDetailsListWrapper = styled.div`
    margin-bottom: 6px;
`;

S.BetSlipDetailsStatusWrapper = styled.div`
    width: 100%;
    height: 30px;
    background-color: ${BetSlipDetailsDataBackground};
`;

S.BetSlipDetailsStatus = styled.div`
    color: ${BetSlipDetailsDataColor};
    font-weight: bold;
    margin-left: 30px;
    line-height: 14px;
`;

S.BetSlipDetailsListHeader = styled.div`
    background-color: ${BetSlipDetailsListHeaderBackground};
    height: 30px;
`;

S.BetSlipDetailsListTitle = styled.div`
    color: ${BetSlipDetailsListHeaderColor};
    line-height: 14px;
    display: flex;
    justify-content: center;
    display: flex;
    justify-content: center;
`;

S.Date = styled(S.BetSlipDetailsListTitle)`
    width: 20%;
`;
S.Event = styled(S.BetSlipDetailsListTitle)`
    width: 32%;
`;
S.Result = styled(S.BetSlipDetailsListTitle)`
    width: 12%;
`;
S.Odds = styled(S.BetSlipDetailsListTitle)`
    width: 12%;
`;
S.Score = styled(S.BetSlipDetailsListTitle)`
    width: 12%;
`;
S.Status = styled(S.BetSlipDetailsListTitle)`
    width: 12%;
`;


S.BetSlipDetailEvent = styled.div`
    background-color: ${BetSlipDetailsListHeaderBackground};
`;

S.EventData = styled.div`
    background-color: ${BetSlipDetailsListEventDataBackground};
    color: ${BetSlipDetailsListEventDataColor};
    height: 67px;
    margin: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

S.EventDateField = styled(S.EventData)`
    width: 20%;
    color: ${BetSlipDetailsListEventDataColorDate};
    font-weight: bold;
`;
S.EventNameField = styled(S.EventData)`
    width: 32%;
    padding-left: 12px;
    align-items: flex-start;
    flex-direction: column;
`;

S.EventName = styled.span`
`;
S.EventGame = styled.span`
`;
S.EventOutcome = styled.span`
`;


S.EventResultField = styled(S.EventData)`
    width: 12%;
`;
S.EventOddsField = styled(S.EventData)`
    width: 12%;
`;
S.EventScoreField = styled(S.EventData)`
    width: 12%;
`;
S.EventStatusField = styled(S.EventData)`
    width: 12%;

    &.pending {
        color: ${BetSlipDetailsListStatusPending};
    }
    &.placed {
        color: ${BetSlipDetailsListStatusPlaced};
    }
    &.won {
        color: ${BetSlipDetailsListStatusWon};
    }
    &.lost {
        color: ${BetSlipDetailsListStatusLost};
    }
    &.cancel {
        color: ${BetSlipDetailsListStatusCancel};
    }
    &.cashout {
        color: ${BetSlipDetailsListStatusCashout};
    }
    &.default {
        color: ${BetSlipDetailsListStatusDefault};
    }
`;

S.Error = styled.div`
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    color: #262626;
    background-color: red;
    margin-top: 0.5rem;
    font-weight: bold;
    height: 3.5rem;
    line-height: 3.5rem;
`;

S.BetSlipDetailsNoResult = styled.div`
    width: 100%;
    text-align: center;
    font-size: 1.3rem;
    margin: 1rem;
`;

export default S;
